
import {aiApi} from './ai'

export const initiateOAuthApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    
    initiateOAuth: builder.mutation({
      query: ({ platform, redirectUri }) => ({
        url: `/social/oauth/${platform}/initiate`,
        method: 'POST',
        body: { redirectUri },
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useInitiateOAuthMutation } = initiateOAuthApi